import React from 'react';
import PropTypes from 'prop-types';

import { registerDecoration } from 'core/forms';

import { Typo } from 'uikit/content';

import styles from '../styles/formDecorationMetadata.module.scss';

const FormDecorationMetadata = ({ fieldKey = '', model = {} }) => (
  <Typo className={styles.element}>{model[fieldKey]}</Typo>
);

FormDecorationMetadata.propTypes = {
  fieldKey: PropTypes.string,
  model: PropTypes.shape({}),
};

registerDecoration('Metadata', FormDecorationMetadata);

export default FormDecorationMetadata;
